// Format currency with period as thousand separator, no decimals
// Example: 1340 -> "$1.340"
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '$0';
  const num = Math.round(Number(amount));
  return '$' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

// Format time duration from minutes
// Example: 125 -> "2h 05m"
export const formatDuration = (totalMinutes) => {
  if (!totalMinutes || totalMinutes < 0) return '0m';
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours === 0) return `${minutes}m`;
  return `${hours}h ${minutes.toString().padStart(2, '0')}m`;
};

// Format date/time for Chile timezone
export const formatDateTime = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  return date.toLocaleString('es-CL', {
    timeZone: 'America/Santiago',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
};

// Format time only
export const formatTime = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  return date.toLocaleTimeString('es-CL', {
    timeZone: 'America/Santiago',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
};

// Calculate elapsed time from entry
export const calculateElapsedMinutes = (entryTime) => {
  if (!entryTime) return 0;
  const entry = new Date(entryTime);
  const now = new Date();
  return Math.floor((now - entry) / 60000);
};

// Calculate live price based on vehicle type config
export const calculatePrice = (entryTime, vehicleType) => {
  if (!entryTime || !vehicleType) return 0;
  
  const minutes = calculateElapsedMinutes(entryTime);
  
  if (vehicleType.is_flat_rate) {
    return vehicleType.flat_rate || 0;
  }
  
  const gracePeriod = vehicleType.grace_period || 0;
  const baseMinutes = vehicleType.base_minutes || 30;
  const basePrice = vehicleType.base_price || 500;
  const extraPerMinute = vehicleType.extra_per_minute || 20;
  const minimumCharge = vehicleType.minimum_charge || 0;
  
  const billableMinutes = Math.max(0, minutes - gracePeriod);
  
  if (billableMinutes <= 0) return 0;
  if (billableMinutes <= baseMinutes) return basePrice;
  
  const extraMinutes = billableMinutes - baseMinutes;
  let price = basePrice + (extraMinutes * extraPerMinute);
  
  if (price > 0 && price < minimumCharge) {
    price = minimumCharge;
  }
  
  return price;
};

// Determine spot alert level based on elapsed time
export const getAlertLevel = (entryTime) => {
  if (!entryTime) return 'normal';
  const minutes = calculateElapsedMinutes(entryTime);
  if (minutes >= 120) return 'critical'; // > 2 hours
  if (minutes >= 60) return 'alert'; // > 1 hour
  return 'normal';
};

// API error handler
export const formatApiError = (error) => {
  if (error?.response?.data?.detail) {
    const detail = error.response.data.detail;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
      return detail.map(e => e?.msg || JSON.stringify(e)).join(' ');
    }
    return JSON.stringify(detail);
  }
  return error?.message || 'An error occurred';
};
